<!--
 * @作者: kerwin
 * @公众号: 大前端私房菜
-->
<template>
  <div>
    <Particles id="tsparticles" :options="options" />

    <div class="formContainer">
      <h3>管理系统</h3>
      <el-form ref="loginFormRef" :model="loginForm" status-icon :rules="loginRules" label-width="80px"
        class="loginform">
        <el-form-item label="手机号" prop="phone">
          <el-input
            v-model.trim="loginForm.phone"
            inputmode="numeric"
            maxlength="11"
            autocomplete="tel"
            placeholder="请输入内部管理员手机号"
          />
        </el-form-item>
        <el-form-item label="验证码" prop="code">
          <div class="code-row">
            <el-input
              v-model.trim="loginForm.code"
              inputmode="numeric"
              maxlength="6"
              autocomplete="one-time-code"
              placeholder="请输入6位验证码"
              @keyup.enter="submitForm"
            />
            <el-button
              class="code-button"
              :disabled="sendingCode || countdown > 0"
              @click="sendCode"
            >
              {{ countdown > 0 ? `${countdown}秒后重发` : (sendingCode ? "发送中..." : "获取验证码") }}
            </el-button>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="loggingIn" @click="submitForm">登录</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script setup>
import { onUnmounted, reactive, ref } from "vue";
import { useRouter } from "vue-router";
import axios from "axios";
import { ElMessage } from "element-plus";
import store from "../store/index"; // 导入 store
// const REQURL = 'http://localhost:3000';


const loginForm = reactive({
  phone: "",
  code: "",
}); // 表单绑定的响应式对象
const loginFormRef = ref(); //表单的引用对象
const sendingCode = ref(false);
const loggingIn = ref(false);
const countdown = ref(0);
let countdownTimer = null;

const phonePattern = /^1[3-9]\d{9}$/;
const codePattern = /^\d{6}$/;

const getApiMessage = (value, fallback) => {
  const data = value?.response?.data ?? value;
  if (typeof data === "string") return data;
  return data?.message || data?.data || fallback;
};

const loginRules = reactive({
  phone: [
    {
      required: true,
      message: "请输入手机号",
      trigger: "blur",
    },
    {
      pattern: phonePattern,
      message: "请输入正确的11位手机号",
      trigger: "blur",
    },
  ],
  code: [
    {
      required: true,
      message: "请输入验证码",
      trigger: "blur",
    },
    {
      pattern: codePattern,
      message: "请输入6位数字验证码",
      trigger: "blur",
    },
  ],
});
const router = useRouter();

const startCountdown = () => {
  countdown.value = 60;
  clearInterval(countdownTimer);
  countdownTimer = setInterval(() => {
    countdown.value -= 1;
    if (countdown.value <= 0) {
      clearInterval(countdownTimer);
      countdownTimer = null;
    }
  }, 1000);
};

const sendCode = async () => {
  if (!phonePattern.test(loginForm.phone)) {
    ElMessage.error("请输入正确的11位手机号");
    return;
  }

  sendingCode.value = true;
  try {
    const { data } = await axios.post("/admin/login/send-code", {
      phone: loginForm.phone,
    });

    if (data.msg !== "success") {
      ElMessage.error(getApiMessage(data, "验证码发送失败"));
      return;
    }

    ElMessage.success("验证码已发送");
    startCountdown();
  } catch (error) {
    ElMessage.error(getApiMessage(error, "验证码发送失败，请稍后重试"));
  } finally {
    sendingCode.value = false;
  }
};

//提交表单函数
const submitForm = () => {
  //1. 校验表单
  loginFormRef.value.validate(async (valid) => {
    if (valid && !loggingIn.value) {
      loggingIn.value = true;
      try {
        const res = await axios.post("/admin/login", {
          phone: loginForm.phone,
          code: loginForm.code,
        });

        if (res.data.msg === "success") {
          store.commit("changeUserInfo", {
            ...(res.data.data || {}),
            role: res.data.data?.role ?? res.data.role,
            scope: res.data.data?.scope ?? res.data.scope,
          });
          store.commit("changeGetterRouter", false);
          router.push("/mainbox");
          return;
        }

        ElMessage.error(getApiMessage(res.data, "手机号或验证码错误"));
      } catch (error) {
        ElMessage.error(getApiMessage(error, "登录失败，请稍后重试"));
      } finally {
        loggingIn.value = false;
      }
    }
  });

  //3. 设置token
  // localStorage.setItem("token", "kerwin");
};

onUnmounted(() => clearInterval(countdownTimer));
//配置particles
const options = {
  background: {
    color: {
      value: "#2d3a4b",
    },
  },
  fpsLimit: 120,
  interactivity: {
    events: {
      onClick: {
        enable: true,
        mode: "push",
      },
      onHover: {
        enable: true,
        mode: "repulse",
      },
      resize: true,
    },
    modes: {
      bubble: {
        distance: 400,
        duration: 2,
        opacity: 0.8,
        size: 40,
      },
      push: {
        quantity: 4,
      },
      repulse: {
        distance: 200,
        duration: 0.4,
      },
    },
  },
  particles: {
    color: {
      value: "#ffffff",
    },
    links: {
      color: "#ffffff",
      distance: 150,
      enable: true,
      opacity: 0.5,
      width: 1,
    },
    collisions: {
      enable: true,
    },
    move: {
      direction: "none",
      enable: true,
      outMode: "bounce",
      random: false,
      speed: 1,
      straight: false,
    },
    number: {
      density: {
        enable: true,
        area: 800,
      },
      value: 80,
    },
    opacity: {
      value: 0.5,
    },
    shape: {
      type: "circle",
    },
    size: {
      random: true,
      value: 5,
    },
  },
  detectRetina: true,
};
</script>

<style lang="scss" scoped>
.formContainer {
  width: 500px;
  min-height: 300px;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: rgba($color: #000000, $alpha: 0.5);
  color: white;
  text-align: center;
  padding: 20px;

  h3 {
    font-size: 30px;
  }

  .loginform {
    margin-top: 20px;
  }
}

.code-row {
  display: flex;
  width: 100%;
  gap: 10px;

  .code-button {
    width: 120px;
    flex: 0 0 120px;
  }
}

:deep(.el-form-item__label) {
  color: white;
}
</style>
